import { deleteCookie, getCookie } from '@amagimedia/api-client';
import type { FC } from 'react';
import { useQuery } from 'react-query';
import { validateUser } from '../apis';
import { Fallback } from '../components/Fallback';
import { AMAGI_NOW_DATA_OBJECT_STORE, USER_SIGNED_OUT_KEY } from '../constants';
import { useIsLocal } from '../hooks/utils';
import { ILoginData, RefreshTokenCookie } from '../types';
import { getDataFromIDB, openIndexDB, setDataInIDB } from '../utils';

export const ValidateUserLoader: FC<IValidateUserLoaderProps> = (props) => {
  const isLocal = useIsLocal();
  const queryRes = useQuery(
    'validate-user',
    async () => {
      if (isLocal) {
        return validateUser();
      }

      //calling validate user only if user has not signed out or refresh token is not expired
      const userSignedOutCookie =
        getCookie<RefreshTokenCookie>(USER_SIGNED_OUT_KEY);
      const db = await openIndexDB();
      if (userSignedOutCookie) {
        await setDataInIDB(
          USER_SIGNED_OUT_KEY,
          userSignedOutCookie,
          AMAGI_NOW_DATA_OBJECT_STORE,
          db,
        );
        deleteCookie(USER_SIGNED_OUT_KEY);
        return null;
      }
      if (userSignedOutCookie === false) {
        await setDataInIDB(
          USER_SIGNED_OUT_KEY,
          userSignedOutCookie,
          AMAGI_NOW_DATA_OBJECT_STORE,
          db,
        );
        deleteCookie(USER_SIGNED_OUT_KEY);
        return validateUser();
      }
      const userSignedOutDataFromIDB = await getDataFromIDB<boolean>(
        USER_SIGNED_OUT_KEY,
        AMAGI_NOW_DATA_OBJECT_STORE,
        db,
      );
      if (
        userSignedOutDataFromIDB ||
        userSignedOutDataFromIDB === undefined ||
        userSignedOutDataFromIDB === null
      ) {
        return null;
      }
      return validateUser();
    },
    {
      retry: false,
      onSuccess(response) {
        if (!response || !response.data) {
          return;
        }
      },
    },
  );

  if (queryRes.isLoading || queryRes.isIdle) {
    return <Fallback />;
  }

  const data = queryRes.data?.data ?? null;
  return props.render(data);
};

interface IValidateUserLoaderProps {
  render: (data: ILoginData | null) => JSX.Element | null;
}
